import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-charcoal text-white relative overflow-hidden">
      {/* Decorative top border */}
      <div className="h-px bg-gradient-gold"></div>
      
      <div className="py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
            <div className="md:col-span-2">
              <div className="relative mb-6">
                <h3 className="font-playfair text-3xl text-white mb-2">
                  MASTER JEWELERS
                </h3>
                <div className="absolute -top-2 -right-4 text-gold-400 text-xl animate-sparkle">✦</div>
              </div>
              <p className="font-cormorant text-lg text-white/70 mb-6 max-w-md">
                Crafting extraordinary jewelry that tells your unique story through 
                the artistry of precious metals and rare gemstones.
              </p>
              <div className="flex space-x-4">
                <a 
                  href="https://facebook.com" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="w-10 h-10 border border-gold-400/30 flex items-center justify-center hover:border-gold-400 hover:bg-gold-400/10 transition-all duration-300 group"
                >
                  <svg className="w-5 h-5 text-gold-400 group-hover:scale-110 transition-transform" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                <a 
                  href="https://instagram.com" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="w-10 h-10 border border-gold-400/30 flex items-center justify-center hover:border-gold-400 hover:bg-gold-400/10 transition-all duration-300 group"
                >
                  <svg className="w-5 h-5 text-gold-400 group-hover:scale-110 transition-transform" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1112.324 0 6.162 6.162 0 01-12.324 0zM12 16a4 4 0 110-8 4 4 0 010 8zm4.965-10.405a1.44 1.44 0 112.881.001 1.44 1.44 0 01-2.881-.001z"/>
                  </svg>
                </a>
              </div>
            </div>
            
            <div>
              <h4 className="font-playfair text-xl text-gold-400 mb-6">Navigation</h4>
              <ul className="space-y-4">
                {[
                  { name: 'About Us', href: '#about' },
                  { name: 'Services', href: '#services' },
                  { name: 'Contact', href: '#contact' }
                ].map((link) => (
                  <li key={link.name}>
                    <a 
                      href={link.href} 
                      className="font-montserrat text-white/70 hover:text-gold-400 transition-colors duration-300 text-sm"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            
            <div>
              <h4 className="font-playfair text-xl text-gold-400 mb-6">Locations</h4>
              <div className="space-y-4 text-sm">
                <div>
                  <p className="font-montserrat text-white/70 mb-1">Alpharetta - North Point</p>
                  <p className="font-montserrat text-white/50">2150 North Point Cir</p>
                  <p className="font-montserrat text-white/50">Alpharetta, GA 30022</p>
                  <p className="font-montserrat text-white/50">(770) 410-1119</p>
                </div>
                <div>
                  <p className="font-montserrat text-white/70 mb-1">Cumming - The Collection</p>
                  <p className="font-montserrat text-white/50">410 Peachtree Pkwy #4114</p>
                  <p className="font-montserrat text-white/50">Cumming, GA 30041</p>
                  <p className="font-montserrat text-white/50">(943) 221-6631</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="border-t border-gold-400/20 py-8 px-6">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center text-sm">
          <p className="font-montserrat text-white/50 mb-4 md:mb-0">
            &copy; {currentYear} Master Jewelers. All rights reserved.
          </p>
          <div className="flex items-center space-x-6 text-white/50">
            <span className="font-montserrat">Lifetime warranty on all custom pieces</span>
            <span className="text-gold-400">✦</span>
            <span className="font-montserrat">For Over 40 Years</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
